import hero from './assets/images/hero.jpg';
import aboutImg from './assets/images/about.jpg';
import programsImg from './assets/images/programs.jpg';

// Auto-import every gallery-N.jpg and video-N.mp4 inside src/assets/*.
// Adding a new gallery-67.jpg or video-20.mp4 will appear automatically.
const buildMap = (req, prefix) => {
  const map = {};
  req.keys().forEach((k) => {
    const m = k.match(new RegExp(`${prefix}-(\\d+)`));
    if (m) map[Number(m[1])] = req(k);
  });
  return map;
};

const galleryMap = buildMap(
  require.context('./assets/images', false, /^\.\/gallery-\d+\.jpg$/),
  'gallery'
);
const videoMap = buildMap(
  require.context('./assets/videos', false, /^\.\/video-\d+\.mp4$/),
  'video'
);

const ordered = (m) =>
  Object.keys(m)
    .map(Number)
    .sort((a, b) => a - b)
    .map((n) => m[n]);

const g = (n) => galleryMap[n];
const v = (n) => videoMap[n];

// ---- Curated "best of" mix (old + new) for the Home page ---------------
// Hero collage rotates through these 5 photos.
export const heroPhotos = [g(13), g(6), g(14), g(11), g(15)].filter(Boolean);

// Photo strip under the hero (8 tiles, alternating old & new).
export const homeStripPhotos = [g(3), g(16), g(7), g(17), g(9), g(18), g(10), g(19)].filter(
  Boolean
);

// Featured videos on Home (mix of an existing favourite + new clips).
export const homeVideos = [v(1), v(4), v(5)].filter(Boolean);
export const homeVideoCaptions = ['🎶 Activity time', '🌟 A new moment', '🏫 Inside our day'];

// ---- Full lists for the Gallery page and background rotator -----------
// allPhotos = the three feature photos (hero/about/programs) + every gallery-N.
export const allPhotos = [hero, aboutImg, programsImg, ...ordered(galleryMap)];

// Back-compat exports (other files import these names).
export const localPhotos = allPhotos;
export const localVideos = ordered(videoMap);
